import { render, staticRenderFns } from "./SiniestroMascotas.vue?vue&type=template&id=34f10978&scoped=true&"
import script from "./SiniestroMascotas.vue?vue&type=script&lang=js&"
export * from "./SiniestroMascotas.vue?vue&type=script&lang=js&"
import style0 from "./SiniestroMascotas.vue?vue&type=style&index=0&id=34f10978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f10978",
  null
  
)

export default component.exports